import React from 'react';
import Stack, { StackProps } from '@mui/material/Stack';
import Typography, { TypographyProps } from '@mui/material/Typography';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { SFPalette } from '@/lib/color';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Box, { BoxProps } from '@mui/material/Box';

function ArrowLinkButton({
  children,
  onClick,
  rightItem,
  typographyProps,
  stackProps,
  buttonProps,
  ...props
}: {
  children?: React.ReactNode;
  onClick: () => void;
  rightItem?: React.ReactNode;
  typographyProps?: TypographyProps;
  stackProps?: StackProps;
  buttonProps?: IconButtonProps;
} & BoxProps) {
  return (
    <Box {...props}>
      <IconButton
        onClick={onClick}
        sx={{
          p: 0,
        }}
        {...buttonProps}
      >
        <Stack direction="row" {...stackProps}>
          <Typography variant="body2" color={SFPalette.grey4} {...typographyProps}>
            {children}
          </Typography>
          <Stack direction="row" color={SFPalette.lightGrey2}>
            {rightItem}
            <ChevronRight />
          </Stack>
        </Stack>
      </IconButton>
    </Box>
  );
}

export default ArrowLinkButton;
